import React,{Component}  from 'react';
import {Flex,Carousel, WingBlank,NoticeBar,Grid} from 'antd-mobile';
import 'antd-mobile/dist/antd-mobile.css'; 
import 'antd-mobile/lib/date-picker/style'; 
import './Home.css'
import {connect} from 'dva';

class Home extends Component {
    constructor(props){
        super(props);
        this.state ={
             url:[],
             grid:[],
             imgHeight: 176,
             AAA004:'手机号未绑定，请绑定手机号',
             notice : '',
        }
    }
    
    componentDidMount() {
        
       this.props.dispatch({type:"index/Grid_module",payload:{
        AAA001:''
       }}).then(()=>{

        this.setState({
          grid:this.props.grid
        });
        

       });
        
        if(localStorage.getItem("AAA004"))
        {
          this.setState({
            AAA004:'供货商：'+localStorage.getItem("AAA004")
          });
          this.props.dispatch({type:"index/Ghs_poster",payload:{
            AAA001:localStorage.getItem("AAA001")
           }}).then(()=>{
             this.setState({
              url:this.props.url
             });
           });
           this.props.dispatch({type:"index/Ghs_notice",payload:{
            AAA001:localStorage.getItem("AAA001")
           }}).then(()=>{
             this.setState({
              notice:this.props.notice
             });
           });
        }
        
    }
    render(){
        return(<div className="homefullScreen" >
            <Flex >
                <img className="headimgurl" src={localStorage.getItem("headimgurl")} alt={localStorage.getItem("nickname")}></img>
                {this.state.AAA004}
            </Flex>
            <hr />
        <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>
       {this.state.notice}
        </NoticeBar>
        <WingBlank>
        <Carousel
          autoplay
          infinite
         
          afterChange={index => this.setState({ slideIndex: index })}
        >
          {this.state.url.map((val, index) => (
            <a
              key={val.url}
              href={val.href}
              style={{ display: 'inline-block', width: '100%', height: this.state.imgHeight }}
            >
              <img
                src={val.url}
                alt="model"
                style={{ width: '100%', verticalAlign: 'top' }}
                onLoad={() => {
                  // fire window resize event to change height
                  window.dispatchEvent(new Event('resize'));
                  this.setState({ imgHeight: 'auto' });
                }}
              />
            </a>
          ))}
        </Carousel>
      </WingBlank>
      <Grid data={this.state.grid}
        columnNum={4}
        hasLine={false}
        renderItem={dataItem => (
        <div style={{ padding: '0px' }} onClick={(e)=> { this.props.dispatch({type:"weixin/changeRouter",payload:{route:dataItem.path}}) }} >
          <img src={dataItem.icon} alt="model" style={{ width: '60%', height: '60%' }}  />
          <div style={{ color: '#888', fontSize: '3vw', marginTop: '0px' }}>
            <span>{dataItem.text}</span>
          </div>
          
        </div>
        
      )}
    />

      </div>);
    }

}

export default connect(state=>{
  return{
    ...state.index,
    loading: state.loading.global
  }
  
})(Home) ;